import React from "react";
import withIntl from "../../utils/withIntl";
import { Box, Grid, IconButton, MenuItem, Select, Typography } from "@material-ui/core";
import { Add, Close } from "@material-ui/icons";
import cloudStore from "../../store/CloudStore";

function MynbonnenUsers(props) {
  const printer = props.printer;
  const [mynbonnenUsers, setMynbonnenUsers] = React.useState(printer.mynbonnen_users);
  const [addUser, setAddUser] = React.useState("");
  const availableUsers = cloudStore.merchant.mynbonnen_merchant?.mynbonnen_users ?? [];

  return (
    <>
      <Grid item xs={12} container spacing={1} style={{ maxWidth: 480 }} alignContent={"center"} alignItems={"center"}>
        <Grid item xs={12}>
          <Typography>
            <Box fontWeight={800}>{props.intl.formatMessage({ id: "orders_users" })}</Box>
          </Typography>
        </Grid>

        {mynbonnenUsers.map((mynbonnenUser, index) => {
          return (
            <>
              <Grid item xs={1}>
                <IconButton
                  size={"small"}
                  onClick={() => {
                    mynbonnenUsers.splice(index, 1);
                    setMynbonnenUsers([...mynbonnenUsers]);
                    props.setMynbonnenUsers([...mynbonnenUsers]);
                  }}
                >
                  <Close />
                </IconButton>
              </Grid>
              <Grid item xs={11}>
                {mynbonnenUser.email}
              </Grid>
            </>
          );
        })}
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <Box fontWeight={800}>{props.intl.formatMessage({ id: "add_orders_user" })}</Box>
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Select
            style={{ width: "100%" }}
            value={addUser}
            onChange={(e) => {
              if (e.target.value !== "") {
                setAddUser(e.target.value);
              }
            }}
          >
            {availableUsers
              .filter((user) => {
                return !mynbonnenUsers.find((mynbonnenUser) => {
                  return user.id === mynbonnenUser.id;
                });
              })
              .map((user) => {
                return <MenuItem value={user}>{user.email}</MenuItem>;
              })}
          </Select>
        </Grid>
        <Grid item xs={1}>
          <IconButton
            size={"small"}
            onClick={() => {
              if (addUser === "") {
                return;
              }
              mynbonnenUsers.push(addUser);
              setMynbonnenUsers([...mynbonnenUsers]);
              props.setMynbonnenUsers([...mynbonnenUsers]);
            }}
          >
            <Add />
          </IconButton>
        </Grid>
      </Grid>
    </>
  );
}

export default withIntl(MynbonnenUsers);
